'use client';

import WalletConnector from '@/src/components/AppComponents/WalletConnector/WalletConnector';
import useWindowSize from '@/src/hooks/useResponsive';
import { MAYZ_LOGO } from '@/src/utils/images';
import Image from 'next/image';
import { MyLink } from '@/src/components/AppComponents/MyLink/MyLInk';
import styles from './Header.module.scss';
import Menu from './Menu';
import Navigation from './Navigation';
import { useAppStore } from '@/src/store/global';
import { useState, useEffect } from 'react';
import { Button } from '../../Commons/Button';
import { isWebsiteDApp, showDappHeaderButton } from '@/src/utils/constants';
import { getWebSitesUrls } from '@/src/utils/routes';

export default function Header() {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //-------------------------------------
    const appStore = useAppStore();
    //--------------------------------------
    const { width } = useWindowSize();
    const hasValidSize = width !== 0; // Check if width has been updated from the initial value
    const isMobile = hasValidSize && width <= 768;
    //--------------------------------------
    const handleOpenWebsite = () => {
        const urls = getWebSitesUrls();
        if (isWebsiteDApp) {
            window.open(urls.governanceUrl, '_blank');
        } else {
            window.open(urls.dappUrl, '_blank');
        }
    };
    return (
        <section className={styles.header}>
            <div className={styles.articleLeft}>
                <MyLink href="/">
                    <div className={styles.logo}>
                        <Image src={MAYZ_LOGO} alt="logo" width="100%" height="100%" layout="responsive" objectFit="contain" priority />
                    </div>
                </MyLink>
                {hasValidSize && !isMobile && <Navigation />}
            </div>
            <div className={styles.articleMid}>
                {isWebsiteDApp ? (
                    <Button
                        className={styles.webBtn}
                        mode="outline"
                        size="small"
                        width={80}
                        arrow
                        title={'Go to MAYZ Governance Portal for buying & minting gMAYZ 🚀'}
                        onClick={() => {
                            handleOpenWebsite();
                        }}
                    >
                        gMAYZ
                    </Button>
                ) : showDappHeaderButton === true ? (
                    <Button
                        className={styles.webBtn}
                        mode="outline"
                        size="small"
                        width={80}
                        arrow
                        title={'Go to MAYZ Funds Portal for index funds & more investment options 🚀'}
                        onClick={() => {
                            handleOpenWebsite();
                        }}
                    >
                        Funds
                    </Button>
                ) : null}
            </div>
            <div className={styles.articleRight}>
                {hasValidSize &&
                    (isMobile ? (
                        <Menu />
                    ) : isRefreshing === false && appStore.isAppStoreLoaded === true ? (
                        <>
                            <WalletConnector isMobile={false} />{' '}
                        </>
                    ) : null)}
            </div>
        </section>
    );
}
